module.exports = __webpack_public_path__ + "img/hxkj-jjfa-1.51bc1abf.svg";